import { Select } from "antd";
import { benefitsIcons } from "../../../core/common/data/json/benefitsIcon";

const { Option } = Select;

const SelectIcon = ({ ...rest }) => {
  return (
    <Select {...rest}>
      {benefitsIcons.map((item) => (
        <Option key={item.value} value={item.value}>
          <div className="flex items-center gap-2">
            <item.Icon color={item.color} size={24} />
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default SelectIcon;
